import { cn } from "../../../utils/useFunctions";
import { STYLE_PAGE, STYLE_PAGE_LANDING } from "../styles/pdf.style";

function PageLanding() {
  return (
    <div className={cn(STYLE_PAGE, "px-0 py-0")}>
      {/* <img className="bg-cover" src={"/images/pdf_one_second.svg"} /> */}
      {/* cover_pdf.jpg */}
      <img className="bg-cover" src={"/images/cover_pdf.jpg"} />
    </div>
  );
}

export default PageLanding;
